<template>
  <div>
    <div>
      <span class="text-danger">*</span> = Required Field
    </div>
    <form @submit.prevent="saveForm" @keydown="clear($event.target.name)">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="course">Course <span class="text-danger">*</span></label>
          <div v-if="errors.course" class="badge badge-danger badge-sm">
            Required
          </div>
          <select class="form-control" v-model="fields.course" id="course">
            <option
              v-for="course_name in courses"
              :key="course_name.id"
              :value="course_name.code"
            >
              {{ course_name.code }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="preceptor"> Select Preceptor <span class="text-danger">*</span></label>
          <div v-if="errors.preceptor_id" class="badge badge-danger badge-sm">
            Required
          </div>
          <select
            id="preceptor"
            v-model="fields.preceptor_id"
            class="form-control"
          >
            <option
              v-for="preceptor in preceptors"
              :key="preceptor.id"
              :value="preceptor.id"
            >
              {{ preceptor.name }}
            </option>
          </select>
        </div>
      </div>
      <div>
        <label>Priority Status <span class="text-danger">*</span></label>
        <div v-if="errors.priority_status" class="badge badge-danger badge-sm">
          Required
        </div>
      </div>
      <div class="form-check form-check-inline">
        <label class="form-check-label">
          <input @change="updateForm"
            class="form-check-input"
            type="radio"
            v-model="fields.priority_status"
            name="priority_status"
            id="priority_status"
            value="Emergency"
          />
          Emergency
        </label>
      </div>
      <div class="form-check form-check-inline">
        <label class="form-check-label">
          <input @change="updateForm"
            class="form-check-input"
            type="radio"
            v-model="fields.priority_status"
            name="priority_status"
            id="priority_status"
            value="Routine"
          />
          Routine
        </label>
      </div>
      <hr />
      <h4>Call Information</h4>
      <div class="form-row">
        <div class="form-group col-6 col-md-3">
          <label> Date <span class="text-danger">*</span></label>
          <span v-if="errors.date" class="badge badge-danger badge-sm"
            >Required</span
          >
<!--          <datepicker :format="customFormatter(this.fields.date)" style="color: black" input-class="form-control" v-model="fields.date" name="date"></datepicker>-->
          <input @change="updateForm"
            autocomplete="off"
            required
            type="text"
            class="form-control"
            data-provide="datepicker"
            id="datePicker"
            placeholder="Choose Date"
            v-model="fields.date"
            name="date"
            data-date-format="yyyy-mm-dd"
            onchange="this.dispatchEvent(new InputEvent('input'))"
          />
        </div>
        <div class="form-group col-6 col-md-3">
          <label for="dispatched_time">Time Dispatched</label>
          <input @change="updateForm"
            type="text"
            class="form-control"
            v-model="fields.dispatched_time"
            id="dispatched_time"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6 col-md-3">
          <label for="time_on_scene">Time On Scene</label>
          <input @change="updateForm"
            type="text"
            class="form-control"
            v-model="fields.time_on_scene"
            name="time_on_scene"
            id="time_on_scene"
          />
        </div>
        <div class="form-group col-6 col-md-3">
          <label for="departure_time">Departure Time</label>
          <input @change="updateForm"
            type="text"
            class="form-control"
            v-model="fields.departure_time"
            name="departure_time"
            id="departure_time"
          />
        </div>
        <div class="form-group col-6 col-md-3">
          <label for="facility_arrival_time  ">Facility Arrival Time</label>
          <input @change="updateForm"
            type="text"
            class="form-control"
            v-model="fields.facility_arrival_time"
            name="facility_arrival_time"
            id="facility_arrival_time"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="delay_explanation">Explain Delays</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.delay_explanation"
          name="delay_explanation"
          id="delay_explanation"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="attending_agengies">Other Attending Agencies</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.attending_agengies"
          name="attending_agengies"
          id="attending_agengies"
          rows="3"
        ></textarea>
      </div>
      <hr />
      <h4>Patient Information</h4>
      <div class="form-group">
        <label for="nature_of_call">Nature of Call <span class="text-danger">*</span></label>
        <span v-if="errors.nature_of_call" class="badge badge-danger badge-sm"
          >Required</span
        >
        <select
          class="form-control"
          v-model="fields.nature_of_call"
          name="nature_of_call"
          id="nature_of_call"
        >
          <option>Medical</option>
          <option>Trauma</option>
          <option
            v-if="
              fields.nature_of_call != 'Medical' &&
              fields.nature_of_call != 'Trauma' &&
              fields.nature_of_call != null
            "
            :value="fields.nature_of_call"
          >
            Other
          </option>
          <option v-else>Other</option>
        </select>
      </div>
      <div
        v-if="
          fields.nature_of_call != 'Medical' &&
          fields.nature_of_call != 'Trauma' &&
          fields.nature_of_call != null
        "
        class="form-group"
      >
        <label>Other</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.nature_of_call"
          name="nature_of_call"
          rows="3"
        ></textarea>
      </div>
      <div class="form-row">
        <div class="form-group col-6 col-md-3">
          <label for="patient_age">Patient Age <span class="text-danger">*</span></label>
          <span v-if="errors.patient_age" class="badge badge-danger badge-sm"
            >Required</span
          >
          <input @change="updateForm"
            type="number"
            class="form-control"
            v-model="fields.patient_age"
            name="patient_age"
            id="patient_age"
          />
        </div>
        <div class="form-group col-6 col-md-3">
          <label for="patient_gender">Gender <span class="text-danger">*</span></label>
          <span v-if="errors.patient_gender" class="badge badge-danger badge-sm"
            >Required</span
          >
          <select
            class="form-control"
            v-model="fields.patient_gender"
            name="patient_gender"
            id="patient_gender"
          >
            <option>Male</option>
            <option>Female</option>
          </select>
        </div>
        <div class="form-group col-6 col-md-3">
          <label for="patient_approx_weight">Approx. Weight (kg)</label>
          <input @change="updateForm"
            type="number"
            class="form-control"
            v-model="fields.patient_approx_weight"
            name="patient_approx_weight"
            id="patient_approx_weight"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="chief_complaint">Chief Complaint <span class="text-danger">*</span></label>
        <span v-if="errors.chief_complaint" class="badge badge-danger badge-sm"
          >Required</span
        >
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.chief_complaint"
          name="chief_complaint"
          id="chief_complaint"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="clinical_impression">Clinical Impression <span class="text-danger">*</span></label>
        <span
          v-if="errors.clinical_impression"
          class="badge badge-danger badge-sm"
          >Required</span
        >
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.clinical_impression"
          name="clinical_impression"
          id="clinical_impression"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="narrative">
          Narrative (brief description of scene, CC, Tx, outcomes) <span class="text-danger">*</span>
        </label>
        <span v-if="errors.narrative" class="badge badge-danger">Required</span>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.narrative"
          name="narrative"
          id="narrative"
          rows="3"
        ></textarea>
      </div>
      <hr />
      <h4>Initial Assessment</h4>
      <div class="form-group">
        <label for="loc">LOC <span class="text-danger">*</span></label>
        <span v-if="errors.loc" class="badge badge-danger">Required</span>
        <select class="form-control" v-model="fields.loc" name="loc" id="loc">
          <option>A</option>
          <option>P</option>
          <option>U</option>
          <option>V</option>
        </select>
      </div>
      <div class="form-group">
        <label for="airway">Airway <span class="text-danger">*</span></label>
        <span v-if="errors.airway" class="badge badge-danger">Required</span>
        <select
          class="form-control"
          v-model="fields.airway"
          name="airway"
          id="airway"
        >
          <option>Patent</option>
          <option
            v-if="fields.airway != 'Patent' && fields.airway != null"
            :value="fields.airway"
          >
            Other
          </option>
          <option v-else>Other</option>
        </select>
      </div>
      <div
        v-if="fields.airway != 'Patent' && fields.airway != null"
        class="form-group"
      >
        <label>Other</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.airway"
          name="airway"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="breathing">Breathing <span class="text-danger">*</span></label>
        <span v-if="errors.breathing" class="badge badge-danger">Required</span>
        <select
          class="form-control"
          v-model="fields.breathing"
          name="breathing"
          id="breathing"
        >
          <option>Normal</option>
          <option>Laboured</option>
          <option
            v-if="
              fields.breathing != 'Normal' &&
              fields.breathing != 'Laboured' &&
              fields.breathing != null
            "
            :value="fields.breathing"
          >
            Other
          </option>
          <option v-else>Other</option>
        </select>
      </div>
      <div
        v-if="
          fields.breathing != 'Normal' &&
          fields.breathing != 'Laboured' &&
          fields.breathing != null
        "
        class="form-group"
      >
        <label>Other</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.breathing"
          name="breathing"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="auscultation">Auscultation Findings <span class="text-danger">*</span></label>
        <span v-if="errors.auscultation" class="badge badge-danger"
          >Required</span
        >
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.auscultation"
          name="auscultation"
          id="auscultation"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="circulation">Circulation <span class="text-danger">*</span></label>
        <span v-if="errors.circulation" class="badge badge-danger"
          >Required</span
        >
        <select
          class="form-control"
          v-model="fields.circulation"
          name="circulation"
          id="circulation"
        >
          <option>Strong</option>
          <option>Regular</option>

          <option
            v-if="
              fields.circulation != 'Strong' &&
              fields.circulation != 'Regular' &&
              fields.circulation != null
            "
            :value="fields.circulation"
          >
            Other
          </option>
          <option v-else>Other</option>
        </select>
      </div>
      <div
        v-if="
          fields.circulation != 'Strong' &&
          fields.circulation != 'Regular' &&
          fields.circulation != null
        "
        class="form-group"
      >
        <label>Other</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.circulation"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="skin_condition">Skin Condition <span class="text-danger">*</span></label>
        <span v-if="errors.skin_condition" class="badge badge-danger"
          >Required</span
        >
        <select
          class="form-control"
          v-model="fields.skin_condition"
          name="skin_condition"
          id="skin_condition"
        >
          <option>Pink/Warm/Dry</option>
          <option
            v-if="
              fields.skin_condition != 'Pink/Warm/Dry' &&
              fields.skin_condition != null
            "
            :value="fields.skin_condition"
          >
            Other
          </option>
          <option v-else>Other</option>
        </select>
      </div>
      <div
        v-if="
          fields.skin_condition != 'Pink/Warm/Dry' &&
          fields.skin_condition != null
        "
        class="form-group"
      >
        <label>Other</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.skin_condition"
          name="skin_condition"
          rows="3"
        ></textarea>
      </div>
      <hr />
      <h4>Transferred Via:</h4>
      <div class="form-check">
        <label class="form-check-label">
          <input @change="updateForm"
            type="radio"
            class="form-check-input"
            v-model="fields.transport_via"
            name="transport_via"
            id="transport_via"
            value="Stretcher"
          />
          Stretcher
        </label>
      </div>
      <div class="form-check">
        <label class="form-check-label">
          <input @change="updateForm"
            type="radio"
            class="form-check-input"
            v-model="fields.transport_via"
            name="transport_via"
            id="transport_via"
            value="Wheelchair at hospital"
          />
          Wheelchair at hospital
        </label>
      </div>
      <div class="form-check">
        <label class="form-check-label">
          <input @change="updateForm"
            type="radio"
            class="form-check-input"
            v-model="fields.transport_via"
            name="transport_via"
            id="transport_via"
            value="Ambulatory"
          />
          Ambulatory
        </label>
      </div>
      <div class="form-check">
        <label class="form-check-label">
          <input @change="updateForm"
            type="radio"
            class="form-check-input"
            v-model="fields.transport_via"
            name="transport_via"
            id="transport_via"
            value="Refused"
          />
          Refused
        </label>
      </div>
      <div v-if="fields.transport_via == 'Refused'" class="form-group">
        <label for="advice_given">Advice Given</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.advice_given"
          name="advice_given"
          id="advice_given"
          rows="3"
        ></textarea>
      </div>
      <label class="pr-3 mt-3">Consent <span class="text-danger">*</span></label>
      <span v-if="errors.consent" class="badge badge-danger">Required</span>
      <div class="form-check form-check-inline">
        <label class="form-check-label">
          <input @change="updateForm"
            class="form-check-input"
            type="radio"
            v-model="fields.consent"
            name="consent"
            id="consent"
            value="Yes"
          />
          Yes
        </label>
      </div>
      <div class="form-check form-check-inline">
        <label class="form-check-label">
          <input @change="updateForm"
            class="form-check-input"
            type="radio"
            v-model="fields.consent"
            name="consent"
            id="consent"
            value="No"
          />
          No
        </label>
      </div>
      <hr />
      <h4>History & Physical (Findings & Pertinent Negatives)</h4>
      <div class="form-group">
        <label for="heent">HEENT</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.heent"
          name="heent"
          id="heent"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="neck">Neck</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.neck"
          name="neck"
          id="neck"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="chest">Chest</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.chest"
          name="chest"
          id="chest"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="abdomen">Abdomen</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.abdomen"
          name="abdomen"
          id="abdomen"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="pelvis">Pelvis</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.pelvis"
          name="pelvis"
          id="pelvis"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="extremities">Extremities</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.extremities"
          name="extremities"
          id="extremities"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="back">Back</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.back"
          name="back"
          id="back"
          rows="3"
        ></textarea>
      </div>
      <hr />
      <h4>Sample Hx</h4>
      <div class="form-group">
        <label for="signs_symptoms">Signs & Symptoms <span class="text-danger">*</span></label>
        <span v-if="errors.signs_symptoms" class="badge badge-danger"
          >Required</span
        >
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.signs_symptoms"
          name="signs_symptoms"
          id="signs_symptoms"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="allergies">Allergies <span class="text-danger">*</span></label>
        <span v-if="errors.allergies" class="badge badge-danger">Required</span>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.allergies"
          name="allergies"
          id="allergies"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="medications">Medications pertinent to C.C. <span class="text-danger">*</span></label>
        <span v-if="errors.medications" class="badge badge-danger"
          >Required</span
        >
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.medications"
          name="medications"
          id="medications"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="pmhx">PmHx <span class="text-danger">*</span></label>
        <span v-if="errors.pmhx" class="badge badge-danger"
          >This field is required.</span
        >
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.pmhx"
          name="pmhx"
          id="pmhx"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="last_oral_intake">Last Oral Intake <span class="text-danger">*</span></label>
        <span v-if="errors.last_oral_intake" class="badge badge-danger"
          >Required</span
        >
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.last_oral_intake"
          name="last_oral_intake"
          id="last_oral_intake"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="events">Events (HxC/C) <span class="text-danger">*</span></label>
        <span v-if="errors.events" class="badge badge-danger">Required</span>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.events"
          name="events"
          id="events"
          rows="3"
        ></textarea>
      </div>
      <hr />
      <h4>OPQRST (Pain Assessment)</h4>
      <div class="form-group">
        <label for="pain_origin">Origin</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.pain_origin"
          name="pain_origin"
          id="pain_origin"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="pain_provokation">Provocation</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.pain_provokation"
          name="pain_provokation"
          id="pain_provokation"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="pain_quality">Quality</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.pain_quality"
          name="pain_quality"
          id="pain_quality"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="pain_region">Region / Radiating</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.pain_region"
          name="pain_region"
          id="pain_region"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="pain_severity">Severity</label>
        <select
          class="form-control"
          v-model="fields.pain_severity"
          name="pain_severity"
          id="pain_severity"
        >
          <option value="">Select</option>
          <option>1</option>
          <option>2</option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
          <option>6</option>
          <option>7</option>
          <option>8</option>
          <option>9</option>
          <option>10</option>
        </select>
      </div>
      <div class="form-row">
        <div class="form-group col-6 col-md-3">
          <label for="pain_onset_time">Time of Onset</label>
          <input @change="updateForm"
            type="text"
            class="form-control"
            v-model="fields.pain_onset_time"
            name="pain_onset_time"
            id="pain_onset_time"
          />
        </div>
      </div>
      <hr id="vitals" />
      <div class="vitals1">
        <h4>Vitals 1 <span class="text-danger">*</span></h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time <span class="text-danger">*</span></label>
            <span
              v-if="errors.hasOwnProperty('vitals1.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals1.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse <span class="text-danger">*</span></label>
            <span
              v-if="errors.hasOwnProperty('vitals1.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals1.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp <span class="text-danger">*</span></label>
            <span
              v-if="errors.hasOwnProperty('vitals1.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals1.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D) <span class="text-danger">*</span></label>
            <span
              v-if="errors.hasOwnProperty('vitals1.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals1.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin <span class="text-danger">*</span></label>
          <span
            v-if="errors.hasOwnProperty('vitals1.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals1.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils <span class="text-danger">*</span></label>
          <span
            v-if="errors.hasOwnProperty('vitals1.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals1.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS <span class="text-danger">*</span></label>
            <span
              v-if="errors.hasOwnProperty('vitals1.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals1.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G <span class="text-danger">*</span></label>
            <span
              v-if="errors.hasOwnProperty('vitals1.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals1.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA % <span class="text-danger">*</span></label>
            <span
              v-if="errors.hasOwnProperty('vitals1.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals1.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 % <span class="text-danger">*</span></label>
            <span
              v-if="errors.hasOwnProperty('vitals1.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals1.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses <span class="text-danger">*</span>
                  <span
                    v-if="errors.hasOwnProperty('vitals1.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals1.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals1.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals1.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor <span class="text-danger">*</span>
                  <span
                    v-if="errors.hasOwnProperty('vitals1.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals1.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals1.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals1.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory <span class="text-danger">*</span>
                  <span
                    v-if="errors.hasOwnProperty('vitals1.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals1.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals1.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals1.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals1.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
      </div>
      <button
        v-if="vitals2Show == false"
        class="btn btn-primary my-3"
        @click="vitals2Show = true"
      >
        Add Vitals
      </button>
      <div class="vitals2 mt-3" v-if="vitals2Show">
        <h4>Vitals 2</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals2.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals2.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals2.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals2.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals2.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals2.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals2.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals2.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals2.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals2.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals2.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals2.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals2.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals2.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals2.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals2.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals2.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals2.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals2.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals2.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals2.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals2.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals2.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals2.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals2.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals2.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals2.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals2.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals2.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals2.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals2.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals2.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals2.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals3Show == false"
          class="btn btn-primary my-3"
          @click="vitals3Show = true"
        >
          Add Vitals
        </button>
        <button
          v-if="vitals2Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals2 = null; vitals2 = {}; vitals2Show = false"
        >
          Clear Vitals 2
        </button>
      </div>
      <div class="vitals3 mt-3" v-if="vitals3Show">
        <h4>Vitals 3</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals3.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals3.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals3.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals3.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals3.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals3.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals3.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals3.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals3.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals3.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals3.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals3.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals3.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals3.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals3.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals3.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals3.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals3.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals3.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals3.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals3.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals3.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals3.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals3.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals3.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals3.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals3.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals3.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals3.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals3.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals3.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals3.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals3.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals4Show == false"
          class="btn btn-primary my-3"
          @click="vitals4Show = true"
        >
          Add Vitals
        </button>
        <button
          v-if="vitals3Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals3 = null; vitals3 = {}; vitals3Show = false"
        >
          Clear Vitals 3
        </button>
      </div>
      <div class="vitals4 mt-3" v-if="vitals4Show">
        <h4>Vitals 4</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals4.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals4.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals4.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals4.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals4.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals4.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals4.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals4.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals4.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals4.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals4.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals4.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals4.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals4.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals4.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals4.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals4.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals4.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals4.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals4.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals4.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals4.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals4.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals4.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals4.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals4.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals4.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals4.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals4.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals4.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals4.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals4.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals4.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals5Show == false"
          class="btn btn-primary my-3"
          @click="vitals5Show = true"
        >
          Add Vitals
        </button>
        <button
          v-if="vitals4Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals4 = null; vitals4 = {}; vitals4Show = false"
        >
          Clear Vitals 4
        </button>
      </div>
      <div class="vitals5 mt-3" v-if="vitals5Show">
        <h4>Vitals 5</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals5.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals5.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals5.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals5.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals5.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals5.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals5.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals5.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals5.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals5.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals5.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals5.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals5.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals5.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals5.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals5.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals5.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals5.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals5.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals5.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals5.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals5.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals5.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals5.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals5.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals5.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals5.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals5.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals5.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals5.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals5.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals5.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals5.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals6Show == false"
          class="btn btn-primary my-3"
          @click="vitals6Show = true"
        >
          Add Vitals
        </button>
        <button
          v-if="vitals5Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals5 = null; vitals5 = {}; vitals5Show = false"
        >
          Clear Vitals 5
        </button>
      </div>
      <div class="vitals6 mt-3" v-if="vitals6Show">
        <h4>Vitals 6</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals6.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals6.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals6.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals6.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals6.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals6.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals6.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals6.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals6.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals6.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals6.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals6.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals6.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals6.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals6.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals6.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals6.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals6.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals6.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals6.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals6.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals6.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals6.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals6.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals6.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals6.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals6.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals6.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals6.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals6.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals6.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals6.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals6.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals7Show == false"
          class="btn btn-primary my-3"
          @click="vitals7Show = true"
        >
          Add Vitals
        </button>
        <button
          v-if="vitals6Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals6 = null; vitals6 = {}; vitals6Show = false"
        >
          Clear Vitals 6
        </button>
      </div>
      <div class="vitals7 mt-3" v-if="vitals7Show">
        <h4>Vitals 7</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals7.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals7.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals7.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals7.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals7.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals7.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals7.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals7.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals7.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals7.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals7.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals7.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals7.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals7.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals7.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals7.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals7.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals7.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals7.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals7.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals7.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals7.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals7.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals7.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals7.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals7.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals7.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals7.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals7.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals7.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals7.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals7.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals7.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals8Show == false"
          class="btn btn-primary my-3"
          @click="vitals8Show = true"
        >
          Add Vitals
        </button>
        <button
          v-if="vitals7Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals7 = null; vitals7 = {}; vitals7Show = false"
        >
          Clear Vitals 7
        </button>
      </div>
      <div class="vitals8 mt-3" v-if="vitals8Show">
        <h4>Vitals 8</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals8.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals8.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals8.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals8.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals8.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals8.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals8.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals8.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals8.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals8.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals8.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals8.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals8.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals8.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals8.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals8.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals8.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals8.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals8.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals8.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals8.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals8.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals8.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals8.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals8.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals8.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals8.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals8.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals8.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals8.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals8.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals8.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals8.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals9Show == false"
          class="btn btn-primary my-3"
          @click="vitals9Show = true"
        >
          Add Vitals
        </button>
        <button
          v-if="vitals8Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals8 = null; vitals8 = {}; vitals8Show = false"
        >
          Clear Vitals 8
        </button>
      </div>
      <div class="vitals9 mt-3" v-if="vitals9Show">
        <h4>Vitals 9</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals9.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals9.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals9.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals9.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals9.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals9.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals9.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals9.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals9.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals9.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals9.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals9.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals9.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals9.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals9.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals9.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals9.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals9.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals9.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals9.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals9.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals9.Pulses" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals9.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals9.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals9.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals9.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals9.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals9.Motor" value="Present" />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals9.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals9.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals9.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals9.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals9.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals10Show == false"
          class="btn btn-primary my-3"
          @click="vitals10Show = true"
        >
          Add Vitals
        </button>
        <button
          v-if="vitals9Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals9 = null; vitals9 = {}; vitals9Show = false"
        >
          Clear Vitals 9
        </button>
      </div>
      <div class="vitals10 mt-3" v-if="vitals10Show">
        <h4>Vitals 10</h4>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>Time</label>
            <span
              v-if="errors.hasOwnProperty('vitals10.Time')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals10.Time"
              name="Time"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Pulse</label>
            <span
              v-if="errors.hasOwnProperty('vitals10.Pulse')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals10.Pulse"
              name="Pulse"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>Resp</label>
            <span
              v-if="errors.hasOwnProperty('vitals10.Resp')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals10.Resp"
              name="Resp"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B/P (S/D)</label>
            <span
              v-if="errors.hasOwnProperty('vitals10.Blood_Pressure')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="text"
              class="form-control"
              v-model="vitals10.Blood_Pressure"
              name="Blood_Pressure"
              placeholder="Systolic/Diastolic"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Skin</label>
          <span
            v-if="errors.hasOwnProperty('vitals10.Skin')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals10.Skin"
            name="Skin"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Pupils</label>
          <span
            v-if="errors.hasOwnProperty('vitals10.Pupils')"
            class="badge badge-danger"
            >Required</span
          >
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals10.Pupils"
            name="Pupils"
            rows="3"
          ></textarea>
        </div>
        <div class="form-row">
          <div class="form-group col-6 col-md-3">
            <label>GCS</label>
            <span
              v-if="errors.hasOwnProperty('vitals10.GCS')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              class="form-control"
              type="number"
              v-model="vitals10.GCS"
              name="GCS"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>B.G</label>
            <span
              v-if="errors.hasOwnProperty('vitals10.BG')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals10.BG"
              name="BG"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 RA %</label>
            <span
              v-if="errors.hasOwnProperty('vitals10.SpO2_Room_Air')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals10.SpO2_Room_Air"
              name="SpO2_Room_Air"
            />
          </div>
          <div class="form-group col-6 col-md-3">
            <label>SpO2 O2 %</label>
            <span
              v-if="errors.hasOwnProperty('vitals10.SpO2_Oxygen')"
              class="badge badge-danger"
              >Required</span
            >
            <input @change="updateForm"
              type="number"
              class="form-control"
              v-model="vitals10.SpO2_Oxygen"
              name="SpO2_Oxygen"
            />
          </div>
        </div>
        <div class="form-group">
          <table class="table table-striped">
            <thead>
              <th></th>
              <th>Absent</th>
              <th>N/A</th>
              <th>Present</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  Pulses
                  <span
                    v-if="errors.hasOwnProperty('vitals10.Pulses')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals10.Pulses"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals10.Pulses" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals10.Pulses"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Motor
                  <span
                    v-if="errors.hasOwnProperty('vitals10.Motor')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals10.Motor" value="Absent" />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals10.Motor" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals10.Motor"
                    value="Present"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Sensory
                  <span
                    v-if="errors.hasOwnProperty('vitals10.Sensory')"
                    class="badge badge-danger"
                    >Required</span
                  >
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals10.Sensory"
                    value="Absent"
                  />
                </td>
                <td>
                  <input @change="updateForm" type="radio" v-model="vitals10.Sensory" value="N/A" />
                </td>
                <td>
                  <input @change="updateForm"
                    type="radio"
                    v-model="vitals10.Sensory"
                    value="Present"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label>Other Vitals</label>
          <textarea @change="updateForm"
            class="form-control"
            v-model="vitals10.Other_Vitals"
            name="Other_Vitals"
            rows="3"
          ></textarea>
        </div>
        <button
          v-if="vitals10Show == true"
          class="btn btn-danger my-3"
          @click.prevent="fields.vitals10 = null; vitals10 = {}; vitals10Show = false"
        >
          Clear Vitals 10
        </button>
      </div>
      <h4>Treatment</h4>
      <div class="form-group">
        <label for="treatment_prior_to_arrival">Tx Prior to Arrival</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.treatment_prior_to_arrival"
          name="treatment_prior_to_arrival"
          id="treatment_prior_to_arrival"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="oxygen">Oxygen</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.oxygen"
          name="oxygen"
          id="oxygen"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="immobilization">Immobilization</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.immobilization"
          name="immobilization"
          id="immobilization"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="splinting">Splinting</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.splinting"
          name="splinting"
          id="splinting"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="wound_care">Wound Care</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.wound_care"
          name="wound_care"
          id="wound_care"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="ecg_monitor">ECG 4-lead Interpretation</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.ecg_monitor"
          name="ecg_monitor"
          id="ecg_monitor"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="ecg_monitor_12">ECG 12-lead Interpretation</label>
        <textarea @change="updateForm"
                  class="form-control"
                  v-model="fields.ecg_monitor_12"
                  name="ecg_monitor_12"
                  id="ecg_monitor_12"
                  rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="iv">IV</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.iv"
          name="iv"
          id="iv"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="cpr">CPR</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.cpr"
          name="cpr"
          id="cpr"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="defib">Defibrillation</label>
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.defib"
          name="defib"
          id="defib"
          rows="3"
        ></textarea>
      </div>
      <div class="form-group">
        <label for="sr_medications"
          >SR Medications (include times, dose, route, and effect)</label
        >
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.sr_medications"
          name="sr_medications"
          id="sr_medications"
          rows="3"
        ></textarea>
      </div>
      <!-- competencies -->
      <span
        v-if="errors.hasOwnProperty('competencies')"
        class="badge badge-danger"
        >No more than 5 competencies can be selected.</span
      >
      <!-- User Interface controls -->
      <b-row>
        <b-col md="7" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="5" class="my-1 text-right">
          <b-form-group label-cols-md="4" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
            <b-btn variant="danger" class="btn-sm" @click="clearCompetencies"><span class="icon icon-trash"></span> Competencies</b-btn>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Main table element -->
      <b-table
        small
        striped
        responsive
        stacked="md"
        :items="items"
        :fields="row_fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        @filtered="onFiltered"
      >
        <template v-slot:cell(title)="row">
          {{ row.item.title }}
          <div>
            <small>{{ row.item.category }}</small>
          </div>
        </template>
        <template v-slot:cell(actions)="row" class="text-nowrap">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <!-- <b-button-group> -->
          <b-button
            @click.stop="row.toggleDetails"
            class="btn btn-success btn-link mb-2"
          >
            Info
          </b-button>
          <input @change="updateForm" type="checkbox" v-model="competencies" :value="row.item.id" />
          <!-- </b-button-group> -->
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <div class="font-weight-bold mb-3">Competency Details</div>
            <table class="table table-striped bg-white table-sm">
              <tbody>
                <tr>
                  <td>
                    <span class="font-weight-bold">Level</span>
                  </td>
                  <td>
                    {{ row.item.task }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="font-weight-bold">Performance Objectives</span>
                  </td>
                  <td>
                    {{ row.item.objectives }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="font-weight-bold"
                      >Directions to Candidate</span
                    >
                  </td>
                  <td>
                    <div v-html="row.item.description"></div>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <div class="font-weight-bold mb-3">Steps</div>
            <table class="table table-striped bg-white table-sm">
              <tbody>
                <tr v-for="(step, index) in row.item.steps" :key="index">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td v-html="step"></td>
                </tr>
              </tbody>
            </table>
            <hr />
            <div v-if="row.item.considerations">
              <div class="font-weight-bold mb-3">
                Considerations / Critical Inclusions
              </div>
              <table class="table table-striped bg-white table-sm">
                <tbody>
                  <tr
                    v-for="(consideration, index) in row.item.considerations"
                    :key="index"
                  >
                    <td>
                      {{ index + 1 }}
                    </td>
                    <td v-html="consideration"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
      <hr />
      <h4>Student Comment</h4>
      <div class="form-group">
        <textarea @change="updateForm"
          class="form-control"
          v-model="fields.student_comments"
          rows="3"
        ></textarea>
      </div>
    </form>
    <!-- FORM ENDS -->
    <div class="text-right fixed-bottom pb-4 pr-1 mb-5 mr-4">
      <div v-if="Object.keys(errors).length !== 0" class="pb-2">
        <span class="badge badge-danger">Please review errors in the form.</span>
      </div>
      <button
        v-if="fields.submitted == false"
        class="btn btn-primary"
        @click.stop="saveForm"
      >
        Save
      </button>
      <button
        v-if="fields.complete == false"
        class="btn btn-warning"
        @click.stop="completeForm"
      >
        Complete
      </button>
      <a href="/pcrs" class="btn btn-danger"> Close </a>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import axios from "axios";
var moment = require("moment");
const items = [];
export default {
  components: {
    Datepicker
  },
  props: [
    "patient_care_report",
    "competency_list",
    "course_list",
    "preceptor_list",
  ],
  data() {
    return {
      moment: moment,
      items: this.competency_list,
      courses: this.course_list,
      preceptors: this.preceptor_list,
      competencies: [],
      row_fields: [
        { key: "title", label: "Competency", sortable: true, class: "tcol2" },
        { key: "actions", label: "Select" },
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: this.competency_list.length,
      pageOptions: [15, 25, 35, 50],
      filter: null,
      sortBy: 'title',
      fields: this.patient_care_report,
      errors: "",
      vitals1: {},
      vitals2: {},
      vitals3: {},
      vitals4: {},
      vitals5: {},
      vitals6: {},
      vitals7: {},
      vitals8: {},
      vitals9: {},
      vitals10: {},
      vitals2Show: false,
      vitals3Show: false,
      vitals4Show: false,
      vitals5Show: false,
      vitals6Show: false,
      vitals7Show: false,
      vitals8Show: false,
      vitals9Show: false,
      vitals10Show: false,
    };
  },
  mounted() {
    if(this.fields.date)
    {
      this.fields.date = moment(this.fields.date).format('YYYY-MM-DD');
    } else {
      this.fields.date = moment().format('YYYY-MM-DD');
    }
    if (this.fields.competencies !== null) {
      this.competencies = this.fields.competencies;
    }
    if (this.fields.vitals1 !== null) {
      this.vitals1 = this.fields.vitals1;
    }
    if (this.fields.vitals2 !== null) {
      this.vitals2 = this.fields.vitals2;
      this.vitals2Show = true;
    }
    if (this.fields.vitals3 !== null) {
      this.vitals3 = this.fields.vitals3;
      this.vitals3Show = true;
    }
    if (this.fields.vitals4 !== null) {
      this.vitals4 = this.fields.vitals4;
      this.vitals4Show = true;
    }
    if (this.fields.vitals5 !== null) {
      this.vitals5 = this.fields.vitals5;
      this.vitals5Show = true;
    }
    if (this.fields.vitals6 !== null) {
      this.vitals6 = this.fields.vitals6;
      this.vitals6Show = true;
    }
    if (this.fields.vitals7 !== null) {
      this.vitals7 = this.fields.vitals7;
      this.vitals7Show = true;
    }
    if (this.fields.vitals8 !== null) {
      this.vitals8 = this.fields.vitals8;
      this.vitals8Show = true;
    }
    if (this.fields.vitals9 !== null) {
      this.vitals9 = this.fields.vitals9;
      this.vitals9Show = true;
    }
    if (this.fields.vitals10 !== null) {
      this.vitals10 = this.fields.vitals10;
      this.vitals10Show = true;
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    clearVital(vital) {
      this.fields.vital = {}
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clear(field) {
      delete this.errors[field];
    },
    clearCompetencies() {
       this.fields.competencies = null;
       this.competencies = [];
    },
    updateForm() {
      if (Object.keys(this.competencies).length !== 0) {
        this.fields = Object.assign({}, this.fields, {
          competencies: this.competencies,
        });
      }
      if (Object.keys(this.vitals1).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals1: this.vitals1 });
      }
      if (Object.keys(this.vitals2).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals2: this.vitals2 });
      }
      if (Object.keys(this.vitals3).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals3: this.vitals3 });
      }
      if (Object.keys(this.vitals4).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals4: this.vitals4 });
      }
      if (Object.keys(this.vitals5).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals5: this.vitals5 });
      }
      if (Object.keys(this.vitals6).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals6: this.vitals6 });
      }
      if (Object.keys(this.vitals7).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals7: this.vitals7 });
      }
      if (Object.keys(this.vitals8).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals8: this.vitals8 });
      }
      if (Object.keys(this.vitals9).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals9: this.vitals9 });
      }
      if (Object.keys(this.vitals10).length !== 0) {
        this.fields = Object.assign({}, this.fields, {
          vitals10: this.vitals10,
        });
      }
      axios
        .post("/pcr/" + this.fields.id + "/update", this.fields)
        .then((response) => {
          if (response.data.id) {
            this.errors = "";
          } else {
            Swal.fire({
              title: "Something went wrong or you lost connection.",
              text: "Please try again.",
            });
          }
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
          } else {
            this.errors = error.response.data.errors;
            Swal.fire({
              title: "Something went wrong.",
              text: "The item you have just entered is causing an error (wrong format, or too many characters), please try something else.  If the issue persists contact support and provide the field name and the text you are trying to enter.",
            }).then((result) => {
              if (result.isConfirmed) {
                this.errors = "";
              }
            });
          }
        });
    },
    saveForm() {
        if(this.competencies.length > 5)
        {
            return Swal.fire({
              title: "Error.",
              text: "You can only add 5 competencies.",
              icon: 'warning'
            })
        }
      if (Object.keys(this.competencies).length !== 0) {
        this.fields = Object.assign({}, this.fields, {
          competencies: this.competencies,
        });
      }
      if (Object.keys(this.vitals1).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals1: this.vitals1 });
      }
      if (Object.keys(this.vitals2).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals2: this.vitals2 });
      }
      if (Object.keys(this.vitals3).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals3: this.vitals3 });
      }
      if (Object.keys(this.vitals4).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals4: this.vitals4 });
      }
      if (Object.keys(this.vitals5).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals5: this.vitals5 });
      }
      if (Object.keys(this.vitals6).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals6: this.vitals6 });
      }
      if (Object.keys(this.vitals7).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals7: this.vitals7 });
      }
      if (Object.keys(this.vitals8).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals8: this.vitals8 });
      }
      if (Object.keys(this.vitals9).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals9: this.vitals9 });
      }
      if (Object.keys(this.vitals10).length !== 0) {
        this.fields = Object.assign({}, this.fields, {
          vitals10: this.vitals10,
        });
      }
      axios
        .post("/pcr/" + this.fields.id + "/update", this.fields)
        .then((response) => {
          this.fields = response.data;
          if (response.data.id) {
            Swal.fire({
              title: "Saved",
              text: "The EPRC was saved successfully.",
              icon: "success",
              confirmButtonText: "Ok",
            });
            this.errors = "";
          } else {
            Swal.fire({
              title: "Something went wrong or you lost connection.",
              text: "Please try again.",
            });
          }
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
          } else {
            Swal.fire({
              title: "Something went wrong.",
              text: "One of the items you have entered is causing an error (wrong format, or too many characters).  If the issue persists contact support and provide the field name and the text you are trying to enter.",
            }).then((result) => {
              if (result.isConfirmed) {
                this.errors = "";
              }
            });
          }
        });
    },
    completeForm() {
        if(this.competencies.length > 5)
        {
            return Swal.fire({
              title: "Error.",
              text: "You can only add 5 competencies.",
              icon: 'warning'
            })
        }
      if (Object.keys(this.competencies).length !== 0) {
        this.fields = Object.assign({}, this.fields, {
          competencies: this.competencies,
        });
      }
      if (Object.keys(this.vitals1).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals1: this.vitals1 });
      }
      if (Object.keys(this.vitals2).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals2: this.vitals2 });
      }
      if (Object.keys(this.vitals3).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals3: this.vitals3 });
      }
      if (Object.keys(this.vitals4).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals4: this.vitals4 });
      }
      if (Object.keys(this.vitals5).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals5: this.vitals5 });
      }
      if (Object.keys(this.vitals6).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals6: this.vitals6 });
      }
      if (Object.keys(this.vitals7).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals7: this.vitals7 });
      }
      if (Object.keys(this.vitals8).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals8: this.vitals8 });
      }
      if (Object.keys(this.vitals9).length !== 0) {
        this.fields = Object.assign({}, this.fields, { vitals9: this.vitals9 });
      }
      if (Object.keys(this.vitals10).length !== 0) {
        this.fields = Object.assign({}, this.fields, {
          vitals10: this.vitals10,
        });
      }
      axios
        .post("/pcr/" + this.fields.id + "/complete", this.fields)
        .then((response) => {
          this.fields = response.data;
          if (response.data.id) {
            this.errors = "";
            Swal.fire({
              title: "Are you sure?",
              text: "You will NOT be able edit after submission.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, Complete!",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/pcr/" + this.fields.id + "/send-complete"
              }
            });
          } else {
            Swal.fire({
              title: "Something went wrong or you lost connection.",
              text: "Please try again.",
            });
          }
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
          } else {
            Swal.fire({
              title: "Something went wrong.",
              text: "One of the items you have entered is causing an error (wrong format, or too many characters).  If the issue persists contact support and provide the field name and the text you are trying to enter.",
            }).then((result) => {
              if (result.isConfirmed) {
                this.errors = "";
              }
            });
          }
        });
    },
  },
};
</script>
